import initVueApp from "@/core.js";
const component = require(`./../views/Login.vue`).default;
initVueApp(component);
